import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { NotificationClientService, NotificationType } from "../../../../../../services/basics/notification-client.service";
import { transient } from "aurelia-framework";
import { ValidationController, ValidationRules } from "aurelia-validation";
import { CustomValidationRenderer } from "../../../../../../client-validation-system/custom-validation-renderer";
import { CwsaStatusClientModel } from "../../../../../../models/cwsa/cwsa.models";
import { CwsaService } from "../../../../../../services/cwsa/cwsa.service";

@transient()
export class VetStatusDialog {

    private _cwSelfAssessmentGuid: string;
    public isDropdownOpen: boolean;
    public canSave: boolean;
    public currentCwsaStatus: CwsaStatusClientModel;
    public cwsaStatuses: CwsaStatusClientModel[] = [];
    public subTaskTypeIds: number[];
    public remarks: string;
    refreshAssignment: () => void;

    constructor(private dialogClientService: DialogClientService, private notificationClientService: NotificationClientService,
        private cwsaService: CwsaService, private validationController: ValidationController) {
        this.validationController.addRenderer(new CustomValidationRenderer());
        ValidationRules
            .ensure('subTaskTypeIds')
            .satisfies((x: number[]) => x && x.length > 0)
            .withMessage("Reason is required")
            .on(this);
    }

    async activate(model: { cwsaStatus: CwsaStatusClientModel, cwSelfAssessmentGuid: string, refreshAssignment: () => void }) {
        this.currentCwsaStatus = model.cwsaStatus;
        this._cwSelfAssessmentGuid = model.cwSelfAssessmentGuid;
        this.cwsaService.getCwsaStatuses({
            cwSelfAssessmentGuid: this._cwSelfAssessmentGuid
        }).then(response => {
            this.cwsaStatuses = response.statuses;
        });
        this.refreshAssignment = model.refreshAssignment;
    }

    openDropdown(event) {
        event.stopPropagation();
        this.isDropdownOpen = !this.isDropdownOpen;
    }

    closeDropdown() {
        this.isDropdownOpen = false;
    }

    cancel() {
        this.dialogClientService.hide();
    }

    async submit() {
        try {
            const validationResponse = await this.validationController.validate();

            if (!validationResponse.valid) return;
            this.cwsaService.changeCwsaStatus({
                newStatusId: this.currentCwsaStatus.statusId,
                cwSelfAssessmentGuid: this._cwSelfAssessmentGuid,
                remarks: this.remarks,
                subTaskTypeIds: this.subTaskTypeIds
            }).then(response => {
                if (response.isSuccessful) {
                    this.dialogClientService.hide();
                    this.refreshAssignment();
                    this.notificationClientService.show("Change status successfully", null, NotificationType.Success);
                }
            });
        } catch (e) {
            this.notificationClientService.show("Change status failed", null, NotificationType.Error);
        }
    }

    changeStatus(status: CwsaStatusClientModel) {
        this.currentCwsaStatus = status;
        this.isDropdownOpen = false;
        this.canSave = true;
    }
}